// extracted by mini-css-extract-plugin
export default {"othersRegnJumbotron":"RegistrationTabs_othersRegnJumbotron__i8ghd","regnJumbotron":"RegistrationTabs_regnJumbotron__T75zg","overlay":"RegistrationTabs_overlay__gN2Xr"};